const slugify = (string = "", separator = "-") => {
  return string
    .toString()
    .normalize("NFD") // split an accented letter in the base letter and the accent
    .replace(/[\u0300-\u036f]/g, "") // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\-_ ]/g, "") // remove all chars not letters, numbers, hyphens and spaces (to be replaced)
    .replace(/\s+/g, separator)
}

const LinkResolver = function (contentType, slug) {
  if (slug === "/") {
    if (contentType === "TemplateList") {
      return "/all/"
    } else if (contentType === "ContentfulTemplateCollectionPage") {
      return "/"
    } else {
      throw new Error(`${contentType} can't have a slug of '/'`)
    }
  }

  const routes = {
    ContentfulTemplate: `/${slugify(slug)}/`,
    ContentfulKpiWorkbook: `/${slugify(slug)}/`,
    ContentfulTemplateCollectionPage: `/collections/${slugify(slug)}/`,
    ContentfulPerson: `/by/${slugify(slug)}/`,
    TemplateList: `/${slugify(slug)}/`,
    KPIWorkbookList: `/kpi-dashboards/`,
    TemplateEcoSystem: `/ecosystem/${slugify(slug)}/`,
  }

  return routes[contentType]
}
module.exports = LinkResolver
